import { render, staticRenderFns } from "./MobExample.vue?vue&type=template&id=9b5b5792&scoped=true&"
import script from "./MobExample.vue?vue&type=script&lang=js&"
export * from "./MobExample.vue?vue&type=script&lang=js&"
import style0 from "./MobExample.vue?vue&type=style&index=0&id=9b5b5792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5b5792",
  null
  
)

export default component.exports